import React, {Fragment} from 'react'


const Events = () => {
    return (
        <Fragment>
            <h1>Events</h1>
        </Fragment>
    )
}

export default Events